export const PRODUCTION_HISTORY_REPORTING_LAG_WEEKS = 3;

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export type ProductionHistoryDateParts = {
  year: number;
  month: number;
  day: number;
};

export function parseIsoDateParts(isoDate: string): ProductionHistoryDateParts | null {
  const [year, month, day] = isoDate.split('-').map(Number);
  if (!year || !month || !day) {
    return null;
  }

  return { year, month, day };
}

/**
 * Same cutoff Revenue Analytics uses: roll the data-boundary date back one incomplete
 * week plus `lagWeeks` (currently 3) so projection math trusts settled paid data only.
 */
export function applyRevenueAnalyticsReportingLag(
  isoDate: string,
  lagWeeks = PRODUCTION_HISTORY_REPORTING_LAG_WEEKS,
): string {
  const parts = parseIsoDateParts(isoDate);
  if (!parts) {
    return isoDate;
  }

  const dataDate = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  const estimationDate = new Date(dataDate.getTime() - WEEK_MS * (1 + lagWeeks));

  return [
    estimationDate.getUTCFullYear(),
    `${estimationDate.getUTCMonth() + 1}`.padStart(2, '0'),
    `${estimationDate.getUTCDate()}`.padStart(2, '0'),
  ].join('-');
}
